import { render, staticRenderFns } from "./VideoSeries.vue?vue&type=template&id=d4991d50&scoped=true&"
import script from "./VideoSeries.vue?vue&type=script&lang=js&"
export * from "./VideoSeries.vue?vue&type=script&lang=js&"
import style0 from "./VideoSeries.vue?vue&type=style&index=0&id=d4991d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4991d50",
  null
  
)

export default component.exports